// Gli upload da admin sono salvati come path relativo /api/uploads/... → prefisso backend
export const resolveMedia = (src) => (src && src.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src);
export const isVideoUrl = (src) => /\.(mp4|webm|mov)(\?|$)/i.test(src || '');
